'use strict';

import * as Firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

export default class FirebaseService {
    constructor(serverIdentification) {
        this.firebase = Firebase;
        let  config = null;
        if(serverIdentification === 'bsiflexyprod') {
             config = {
                apiKey: "AIzaSyBFZ6UcO_gYJraHA7-lxF1HtzeyHlsoo08",
                authDomain: "bsiflexyprod.firebaseapp.com",
                databaseURL: "https://bsiflexyprod.firebaseio.com",
                projectId: "bsiflexyprod",
                storageBucket: "bsiflexyprod.appspot.com",
                messagingSenderId: "154950419584"
            };
        }
        else if(serverIdentification === 'bsiflexyqa') {
             config = {
                apiKey: "AIzaSyC2MEsABoUubQwaMHnaYF4lsuPhUpFgmi8",
                authDomain: "bsiflexyqa.firebaseapp.com",
                databaseURL: "https://bsiflexyqa.firebaseio.com",
                projectId: "bsiflexyqa",
                storageBucket: "bsiflexyqa.appspot.com",
                messagingSenderId: "278524302071"
            };

        }
        else if(serverIdentification === 'bsiflexydev') {
             config = {
                apiKey: "AIzaSyDqOskUYKHe1ZOC-ty7AKjcjxqCEAjEBe0",
                authDomain: "bsiflexydev.firebaseapp.com",
                databaseURL: "https://bsiflexydev.firebaseio.com",
                projectId: "bsiflexydev",
                storageBucket: "",
                messagingSenderId: "923528606600"
            };
        }
        this.firebase.initializeApp(config);
        this.database = this.firebase.database();
        this.auth = this.firebase.auth();
    }
}

angular.module('FlexyBeautyApp.services').
factory('FirebaseServiceFactory',['UserData', function (UserData) {
    return {
        firebaseservice: null,

        getFireBaseService: function () {
            let loggedUser = UserData.getLoggedUser();
            if (!this.firebaseservice && loggedUser && loggedUser.serverIdentification) {
                this.firebaseservice = new FirebaseService(loggedUser.serverIdentification.applicationId);
            }
            return this.firebaseservice
        }
    };
}
]);



// WEBPACK FOOTER //
// ./js/services/tools/firebase.service.js